import {
  HubSpotAnalyticsEvent,
  HubSpotAnalyticsEventMetadata,
} from './useAnalyticsHose'

/**
 * A mapping of HubSpotAnalyticsEvent to Google Tag Manager event names
 */
export const legacyGtmEventNameMapping: Record<HubSpotAnalyticsEvent, string> =
  {
    CREATED_FIRST_PERSONAL_APP: 'createdFirstPersonalApp',
    CREATED_PERSONAL_APP: 'createdPersonalApp',
    CREATED_ORGANIZATION_APP: 'createdOrganizationApp',
    CREATED_FIRST_ORGANIZATION_APP: 'createdFirstOrganizationApp',
    CREATED_ORGANIZATION: 'organizationCreated',
    SYNCED_USER_COLLECTION: 'syncedUserCollection',
  }

/**
 * A function to take a HubSpotAnalyticsEventMetadata and return event metadata
 * that GTM expects to receive.
 *
 * The conversion mostly just takes any top-level object properties and returns
 * them as-is, since GTM expects to receive a flat object where as our backend
 * expects to receive a nested object.
 */
export const toLegacyGtmMeta = (meta?: HubSpotAnalyticsEventMetadata) => {
  if (!!meta?.appEvent) {
    return meta.appEvent
  } else if (!!meta?.organizationEvent) {
    return meta.organizationEvent
  } else if (!!meta?.appDataEvent) {
    return meta.appDataEvent
  } else {
    return undefined
  }
}
